export const FeatureGate = {
  BETA_LINK_REDIRECT: "quiz_beta_link_redirect",
};
